import React, { Component } from "react";
import { POST, loading, token } from "../components/CustomComponent.js";
import LOGO from "../assets/images/logo-transparant-white.png"
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Download extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    loading(false);
  }
  render() {
    return (
      <div className="w-100 min-vh-100 bg-primary">
        <div className="w-100 bg-primary row align-items-end">
          <div className="col-12 col-lg-6 p-5 d-flex align-items-center" style={{minHeight:"80vh"}}>
          <div className="d-block d-lg-none w-100 mx-auto">
              <h1 className="fw-bold mb-3">Smart Cane PRO</h1>
              <h6 className="mb-4" style={{textIndent:60, lineHeight: 1.5}}>Smart Cane Pro คือแอป GIS สำหรับติดตามและบริหารจัดการพื้นที่ปลูกอ้อย ช่วยบันทึกข้อมูลแปลงอ้อย ตรวจสอบพิกัด ประเมินคุณภาพอ้อย (เกรด A B C) รายงานพื้นที่น้ำท่วม หรือติดฝน และติดตามสถานะการตัดอ้อยแบบเรียลไทม์ผ่านแผนที่ แอปรองรับการทำงานออฟไลน์ และเชื่อมต่อฐานข้อมูลกลางเพื่อให้ผู้บริหารวางแผนและตัดสินใจได้แม่นยำยิ่งขึ้น</h6>
              <a className="btn btn-dark px-3 pointer" href="/assets/files/Smart_Cane_Pro.apk" download><span className="icon me-2 text-white">{'\uf3ce'}</span>ดาวน์โหลด Smart_Cane_Pro.apk</a>
            </div>
            <div className="d-none d-lg-block w-75 mx-auto">
              <h1 className="fw-bold mb-3">Smart Cane PRO</h1>
              <h6 className="mb-4" style={{textIndent:60, lineHeight: 1.5}}>Smart Cane Pro คือแอป GIS สำหรับติดตามและบริหารจัดการพื้นที่ปลูกอ้อย ช่วยบันทึกข้อมูลแปลงอ้อย ตรวจสอบพิกัด ประเมินคุณภาพอ้อย (เกรด A B C) รายงานพื้นที่น้ำท่วม หรือติดฝน และติดตามสถานะการตัดอ้อยแบบเรียลไทม์ผ่านแผนที่ แอปรองรับการทำงานออฟไลน์ และเชื่อมต่อฐานข้อมูลกลางเพื่อให้ผู้บริหารวางแผนและตัดสินใจได้แม่นยำยิ่งขึ้น</h6>
              <a className="btn btn-dark px-3 pointer" href="/assets/files/Smart_Cane_Pro.apk" download><span className="icon me-2 text-white">{'\uf3ce'}</span>ดาวน์โหลด Smart_Cane_Pro.apk</a>
            </div>
          </div>
          <div className="col-12 col-lg-6 d-flex align-items-end justify-content-center position-relative text-center px-0">
            <div className="d-none d-sm-block d-md-block d-lg-none" style={{minHeight:370}}></div>
            <div className="d-block d-sm-none" style={{minHeight:100}}></div>
            <img alt="app" src={require('../assets/images/app.png')} className="position-absolute w-75" style={{bottom: "-10vh", minWidth: 200}}/>
          </div>
        </div>
        <div className="w-100 bg-light" style={{height:"20vh"}}></div>
      </div>
    );
  }
}
